export enum CloudManagerViewState{
  showActivateTrialPrompts = 1,
  showAddCustomersPrompts = 2,
  showRunCommandPrompts = 3,
  showCommandCenterPrompts = 4
}
